const steps = [
  {
    number: "01",
    title: "Chame no WhatsApp",
    desc: "Você fala com nossa equipe e informa qual certificado precisa.",
    icon: "ri-message-3-line",
  },
  {
    number: "02",
    title: "Envie os documentos",
    desc: "Orientamos exatamente o que você precisa enviar para evitar erro ou atraso.",
    icon: "ri-upload-cloud-2-line",
  },
  {
    number: "03",
    title: "Faça a validação por videoconferência",
    desc: "O processo é feito online, com segurança e praticidade.",
    icon: "ri-video-chat-line",
  },
  {
    number: "04",
    title: "Receba e instale seu certificado",
    desc: "Depois da aprovação, você recebe o certificado e conta com nosso suporte para começar a usar.",
    icon: "ri-shield-check-line",
  },
];

export default function HowItWorks() {
  return (
    <section id="como-funciona" className="relative py-20 md:py-24 bg-primary-500 overflow-hidden">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)",
          backgroundSize: "32px 32px"
        }} />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-500/10 px-3 py-1 text-xs font-medium text-accent-400">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            Como funciona
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-semibold text-background-50 font-heading">
            Como emitir seu certificado digital com a AVcertifica
          </h2>
        </div>

        <div className="mt-16 relative">
          {/* Timeline line for desktop */}
          <div className="hidden lg:block absolute top-8 left-[12.5%] right-[12.5%] h-px">
            <div className="h-full bg-gradient-to-r from-accent-500 via-accent-400 to-accent-500 opacity-40" />
          </div>

          <div className="grid lg:grid-cols-4 gap-8">
            {steps.map((step) => (
              <div key={step.number} className="relative">
                <div className="relative z-10 mx-auto lg:mx-0 h-16 w-16 rounded-2xl bg-primary-600 border border-accent-500/30 flex items-center justify-center">
                  <i className={`${step.icon} text-xl text-accent-400`}></i>
                </div>
                <div className="mt-5 text-center lg:text-left">
                  <div className="text-xs text-accent-400 font-medium">Passo {parseInt(step.number)}</div>
                  <div className="mt-1 font-heading text-xl text-background-50 font-semibold">{step.title}</div>
                  <p className="mt-2 text-sm text-background-50/65">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href="https://wa.me/5547991891311"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-6 py-3.5 text-primary-950 font-medium hover:bg-background-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line"></i>
            Começar agora pelo WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}